// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton-style_skeleton__3H69s","skeleton-wave":"skeleton-style_skeleton-wave__26Pyn"};